import cx from 'classnames';
import { TablePagination } from '../TablePagination/TablePagination';
import { Table } from '../Table';
import useIsMobile from '../../hooks/useIsMobile';

export const TableWithPagination = ({
  className,
  hasInnerScroll = false,
  totalRows = 0,
  currentPage,
  perPage,
  isLoading,
  screen,
  changeValue,
  stickyHeader,
  ...tableProps
}) => {
  const isMobile = useIsMobile();
  const tableStickyHeader = !isMobile && tableProps.rows.length ? stickyHeader : undefined;
  const containerClassName = isMobile ? 'mobile-table__container' : 'custom-table__container';
  const wrapperClassName = isMobile ? 'mobile-table__wrapper' : 'custom-table__wrapper';

  return (
    <div
      className={cx(containerClassName, className, {
        'inner-scroll': hasInnerScroll,
      })}
    >
      <div
        className={cx(wrapperClassName, {
          'custom-table__wrapper-sticky': !!tableStickyHeader,
        })}
      >
        <Table isLoading={isLoading} screen={screen} {...tableProps} stickyHeader={tableStickyHeader} />
        <TablePagination
          isLoading={isLoading}
          mobile={isMobile}
          totalRows={totalRows}
          page={currentPage}
          perPage={perPage}
          siblingCount={1}
          onChangePage={value => changeValue('page', value)}
          onChangePerPage={value => changeValue('limit', value)}
        />
      </div>
    </div>
  );
};
